export const name = "KLL_QUANTILES.MERGE_PARTIAL";
export const summary = `Merges KLL sketches of the same underlying type into a new sketch.`;
export const reference = `
## KLL_QUANTILES.MERGE_PARTIAL

Merges KLL sketches of the same underlying type into a new sketch.

\`\`\`
KLL_QUANTILES.MERGE_PARTIAL(sketch)
\`\`\`

### Description

Takes KLL sketches of the same underlying type and merges them to return a new sketch of the same underlying type. This is an aggregate function.

If the merged sketches were initialized with different precisions, the precision is downgraded to the lowest precision involved in the merge — except if the aggregations are small enough to still capture the input exactly — then the mergee's precision is maintained.

Returns an error if two or more sketches don't have compatible underlying types, such as one sketch of \`INT64\` values and another of\`FLOAT64\` values.

Returns an error if one or more inputs aren't a valid KLL quantiles sketch.

Ignores \`NULL\` sketches. If the input contains zero rows or only \`NULL\`sketches, the function returns \`NULL\`.


### Supported Argument Types

- \`sketch\`: \`BYTES\` KLL sketch


### Return Type

KLL sketch as \`BYTES\`


### Example

The following query initializes two KLL sketches from five rows of data each. Then it merges these two sketches into a new sketch, also as \`BYTES\`. Both input sketches have the same underlying data type and precision.



\`\`\`
SELECT KLL_QUANTILES.MERGE_PARTIAL(kll_sketch) AS merged_sketch
FROM (SELECT KLL_QUANTILES.INIT_INT64(x, 1000) AS kll_sketch
      FROM (SELECT 1 AS x UNION ALL
            SELECT 2 AS x UNION ALL
            SELECT 3 AS x UNION ALL
            SELECT 4 AS x UNION ALL
            SELECT 5)
      UNION ALL
      SELECT KLL_QUANTILES.INIT_INT64(x, 1000) AS kll_sketch
      FROM (SELECT 6 AS x UNION ALL
            SELECT 7 AS x UNION ALL
            SELECT 8 AS x UNION ALL
            SELECT 9 AS x UNION ALL
            SELECT 10 AS x));
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
